import request from './request'

export function postTrialApply(data) {
  return request({
    url: '/api/v2/form/trialApply',
    method: 'post',
    data: data
  })
}
export function postTrialApplyV2(data) {
  return request({
    url: '/api/v2/form/trialApplyV2',
    method: 'post',
    data: data
  })
}

export function getTrialApplyStatus(company) {
  return request({
    url: '/api/v2/form/trialApply/status',
    method: 'get',
    params: {
      company: company
    }
  })
}
export function getTrialApplyStatusV2(company) {
  return request({
    url: '/api/v2/form/trialApply/statusV2',
    method: 'get',
    params: {
      company: company
    }
  })
}

export function postTrialSendMail(company, email) {
  return request({
    url: '/api/v2/form/trialApply/sendMail',
    method: 'post',
    data: {
      company: company,
      email: email
    }
  })
}
export function postTrialSendMailV2(company, email) {
  return request({
    url: '/api/v2/form/trialApply/sendMailV2',
    method: 'post',
    data: {
      company: company,
      email: email
    }
  })
}

export function getAreaData(parent_id, depth) {
  return request({
    url: '/api/v2/area/tree',
    method: 'get',
    params: {
      parent_id: parent_id,
      depth: depth
    }
  })
}

export function postTrialUnitApplyV2(data) {
  return request({
    url: '/api/v2/form/enterpriseApplyV2',
    method: 'post',
    data: data
  })
}
